import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Logout from '../logout';

const UserAvatar = ({ user }) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const overlayRef = useRef(null);

  const handleAvatarClick = () => {
    setIsOverlayOpen(!isOverlayOpen);
  };

  const handleDocumentClick = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
      setIsOverlayOpen(false);
    }
  };

  useEffect(() => {
    if (isOverlayOpen) {
      document.addEventListener('click', handleDocumentClick);
    } else {
      document.removeEventListener('click', handleDocumentClick);
    }

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [isOverlayOpen]);

  return (
    <div className="relative w-10 h-10" ref={overlayRef}>
      <div onClick={handleAvatarClick}>
        {user ? (
          <img
            // src={user.photoURL}
            src={user.picture || 'https://ionicframework.com/docs/img/demos/avatar.svg'}
            className="w-10 h-10 rounded-full cursor-pointer"
            alt="user avatar"
          />
        ) : (
          <div className="w-10 bg-black-transparent h-11 animate-pulse rounded-full" />
        )}
      </div>

      {isOverlayOpen && (
        <div className="absolute top-0 right-0 mt-12 mr-2 bg-white border border-black-transparent rounded shadow z-10">
          <Logout />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps, null)(UserAvatar);
